// Universal Create button wrapper
export const GLOBAL_CREATE_BUTTON_WRAPPER =
	'atlassian-navigation.ui.universal-create.universal-create-wrapper';
